module.exports = __webpack_public_path__ + "static/media/bfdl_announcement_button.846e02a3.svg";